import { render, staticRenderFns } from "./IconCake.vue?vue&type=template&id=1cc03796&"
import script from "./IconCake.vue?vue&type=script&lang=js&"
export * from "./IconCake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports